
import { CToken } from '../function/axios'

export let cancelGetProduct
export let cancelGetUpsell
export let cancelSubmitAUSCheck
export let cancelSubmitEPPCheck

export default {
  getProduct: (ids,promo=null) => {
    if(promo){
      return window.ccpAxios.post('/api/products', {
        ids,
        promo
      },{
        cancelToken: new CToken(function(c){
          cancelGetProduct = c
        })
      })
    }
    return window.ccpAxios.post('/api/products', {
      ids
    },{
      cancelToken: new CToken(function(c){
        cancelGetProduct = c
      })
    })
  },
  getUpsell: () =>{
    let upsellIDs = [561]
    if(window && window.app_config && window.app_config){
      let {upsell} = window.app_config
      try {
        const upsellJSON = JSON.parse(`[${upsell}]`)
        if(upsellJSON && Array.isArray(upsellJSON) && typeof upsellJSON[0]==="object" ){
          upsellIDs = upsellJSON.map(item=>item.id)
        }else{
          upsell = upsell.split(",")
          if(upsell && Array.isArray(upsell)){
            upsellIDs = upsell
          }
        }
      }catch (e) {
        upsell = upsell.split(",")
        if(upsell && Array.isArray(upsell)){
          upsellIDs = upsell
        }
      }
    }
    return window.ccpAxios.post('/api/products', {
      ids: upsellIDs
    },{
      cancelToken: new CToken(function(c){
        cancelGetUpsell = c
      })
    })
  },
  getConnectorProduct: (id) =>{
    return window.ccpAxios.post('/api/products', {
      ids: [id]
    })
  },
  submitEPPCheck: (domain, epp) => {
    return window.ccpAxios.post('/api/epp/check', {
      domain,
      epp
    },{
      cancelToken: new CToken(function(c){
        cancelSubmitEPPCheck = c
      })
    })
  },
  submitAUSCheck: (number, type) => {
    return window.ccpAxios.post('/api/au/eligibility', {
      eligibility_number: number,
      eligibility_type: type
    },{
      cancelToken: new CToken(function(c){
        cancelSubmitAUSCheck = c
      })
    })
  }
}
